import { useState } from 'react'
import { Icon, type IconName } from './icons'

export interface HowStep { icon: IconName; title: string; text: string }

function wasClosed(id: string): boolean {
  try { return localStorage.getItem(`how:${id}`) === 'closed' } catch { return false }
}

/** A short, collapsible explanation at the top of a page. Open the first time; remembers if you close it. */
export default function HowItWorks({ id, title = 'How this works', lead, steps }: { id: string; title?: string; lead?: string; steps: HowStep[] }) {
  const [open, setOpen] = useState(() => !wasClosed(id))
  return (
    <details className="how" open={open} onToggle={(e) => {
      const now = (e.currentTarget as HTMLDetailsElement).open
      setOpen(now)
      try { localStorage.setItem(`how:${id}`, now ? 'open' : 'closed') } catch { /* private window: it simply opens again next time */ }
    }}>
      <summary><span className="ico"><Icon name="bulb" size={18} /></span>{title}<span className="chev"><Icon name="chevron" size={18} /></span></summary>
      <div className="how-body">
        {lead && <p className="how-lead">{lead}</p>}
        <ol className="how-steps">
          {steps.map((s) => <li key={s.title}><span className="ico"><Icon name={s.icon} size={18} /></span><b>{s.title}</b><span>{s.text}</span></li>)}
        </ol>
      </div>
    </details>
  )
}
